export type UnitMappingField = {
  group: string;
  field: string;
};

export const FIELD_LIST = [
  { group: "Basic", field: "BRAND_NAME" },
  { group: "Basic", field: "PRODUCT_ORDER" },
  { group: "Category", field: "CAT_GROUP_ID" },
  { group: "Features", field: "REFERENCE_FEATURE_SYSTEM_NAME" },
  { group: "Features", field: "REFERENCE_FEATURE_GROUP_ID" },
  { group: "Features", field: "REFERENCE_FEATURE_GROUP_ID2" },
  { group: "Features", field: "REFERENCE_FEATURE_GROUP_NAME" },
  { group: "Features", field: "FNAME" },
  { group: "Features", field: "FVALUE" },
  { group: "Features", field: "FUNIT" },
  { group: "Legal", field: "BIOCIDAL_FEATURE" },
  { group: "Legal", field: "BIOCIDAL_INGREDIENT" },
  { group: "Legal", field: "WEEE_NUMBER" },
  { group: "Legal", field: "HAZMAT_CLASS" },
  { group: "Legal", field: "WARRANTY_CLASS" },
  { group: "Logistic", field: "COUNTRY_OF_ORIGIN" },
  { group: "Mimes", field: "MIME_PURPOSE" },
  { group: "Mimes", field: "MIME_TYPE" },
  { group: "Mimes", field: "MIME_DESCR" },
  { group: "Mimes", field: "MIME_ALT" },
  { group: "OrderDetails", field: "ORDER_UNIT" },
  { group: "OrderDetails", field: "CONTENT_UNIT" },
  { group: "OrderDetails", field: "CONTENT_PACKAGE" },
  { group: "Packing", field: "PACKING_UNIT" },
  { group: "Price", field: "PRICE_TYPE" },
  { group: "Price", field: "PRICE_CURRENCY" },
  { group: "Price", field: "TAX" },
  { group: "Price", field: "TERRITORY" },
  { group: "Suppliers", field: "SUPPLIER_ID" },
  { group: "Suppliers", field: "SUPPLIER_NAME" },
  { group: "Suppliers", field: "SUPPLIER_DISCOUNT_GROUP_CODE" },
  { group: "Suppliers", field: "SUPPLIER_PRICE_ALLOCATION_UNIT_CODE" },
  { group: "Suppliers", field: "SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL" },
  { group: "Suppliers", field: "SUPPLIER_CONTENT_UNIT_CODE" },
  { group: "Udx", field: "UDX" },
  { group: "Wawi", field: "LINE_1" },
  { group: "Wawi", field: "LINE_2" },
  { group: "Wawi", field: "LINE_3" },
  { group: "Wawi", field: "LINE_4" },
  { group: "Wawi", field: "CUSTOM_FIELD" },
] as const satisfies readonly UnitMappingField[];

export const GROUP_LIST = Array.from(
  new Set(FIELD_LIST.map(x => x.group))
);
